import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { BuyAndGetYPctDiscountModel } from '@/b2c/shared/api/server-apis';
import { GlobalLabels } from '@/shared/content/site-context.store';
import GlobalLabelWithNamedArguments from '@/shared/GlobalLabelWithNamedArguments.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyXAndGetYPercent',
  props: {
    label: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.label)
    ? (_openBlock(), _createBlock(GlobalLabelWithNamedArguments, {
        key: 0,
        class: "o-text-caption px-8 py-4 bg-brandy whitespace-nowrap",
        label: __props.label.label,
        namespace: _unref(GlobalLabels).byXAndGetYInDiscount
      }, null, 8, ["label", "namespace"]))
    : _createCommentVNode("", true)
}
}

})